// extracted by mini-css-extract-plugin
export var bodyRow = "_ez-d";
export var cardColumns = "_ez-e";
export var ellipsesOverflow = "_ez-2";
export var flatBottomCorners = "_ez-3";
export var flatTopCorners = "_ez-4";
export var headerActionsDropdown = "_ez-f";
export var headerBottomRow = "_ez-c";
export var headerTopRow = "_ez-b";
export var orderDetailsWrapper = "_ez-0";
export var orderInfoContainer = "_ez-1";
export var productDetails = "_ez-9";
export var productImage = "_ez-5";
export var responsiveTable = "_ez-8";
export var shipmentContainer = "_ez-a";
export var tableBottomLeft = "_ez-6";
export var tableBottomRight = "_ez-7";
export var trackingLink = "_ez-g";